/* tslint:disable */
/* eslint-disable */
/**
 * C4 Links Collab Catman API
 * API documentation for C4 Links Collab Catman
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setBearerAuthToObject,
  setSearchParams,
  toPathString,
  createRequestFunction
} from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * SupplierApi - axios parameter creator
 */
export const SupplierApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get supplier key and desc list
     * @param {string} search
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSupplierKey: (search_1, page_1, pageSize_1, ...args_1) =>
      __awaiter(
        this,
        [search_1, page_1, pageSize_1, ...args_1],
        void 0,
        function* (search, page, pageSize, options = {}) {
          // verify required parameter 'search' is not null or undefined
          assertParamExists('getSupplierKey', 'search', search);
          const localVarPath = `/api/supplier/key`;
          // use dummy base URL string because the URL constructor only accepts absolute URLs.
          const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
          let baseOptions;
          if (configuration) {
            baseOptions = configuration.baseOptions;
          }
          const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
          const localVarHeaderParameter = {};
          const localVarQueryParameter = {};
          // authentication authorization required
          // http bearer authentication required
          yield setBearerAuthToObject(localVarHeaderParameter, configuration);
          if (page !== undefined) {
            localVarQueryParameter['page'] = page;
          }
          if (pageSize !== undefined) {
            localVarQueryParameter['pageSize'] = pageSize;
          }
          if (search !== undefined) {
            localVarQueryParameter['search'] = search;
          }
          localVarHeaderParameter['Accept'] = 'application/json';
          setSearchParams(localVarUrlObj, localVarQueryParameter);
          let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
          localVarRequestOptions.headers = Object.assign(
            Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions),
            options.headers
          );
          return {
            url: toPathString(localVarUrlObj),
            options: localVarRequestOptions
          };
        }
      )
  };
};
/**
 * SupplierApi - functional programming interface
 */
export const SupplierApiFp = function (configuration) {
  const localVarAxiosParamCreator = SupplierApiAxiosParamCreator(configuration);
  return {
    /**
     * Get supplier key and desc list
     * @param {string} search
     * @param {number} [page]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSupplierKey(search, page, pageSize, options) {
      return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const localVarAxiosArgs = yield localVarAxiosParamCreator.getSupplierKey(search, page, pageSize, options);
        const localVarOperationServerIndex =
          (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null &&
          _a !== void 0
            ? _a
            : 0;
        const localVarOperationServerBasePath =
          (_c =
            (_b = operationServerMap['SupplierApi.getSupplierKey']) === null || _b === void 0
              ? void 0
              : _b[localVarOperationServerIndex]) === null || _c === void 0
            ? void 0
            : _c.url;
        return (axios, basePath) =>
          createRequestFunction(
            localVarAxiosArgs,
            globalAxios,
            BASE_PATH,
            configuration
          )(axios, localVarOperationServerBasePath || basePath);
      });
    }
  };
};
/**
 * SupplierApi - factory interface
 */
export const SupplierApiFactory = function (configuration, basePath, axios) {
  const localVarFp = SupplierApiFp(configuration);
  return {
    /**
     * Get supplier key and desc list
     * @param {SupplierApiGetSupplierKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSupplierKey(requestParameters, options) {
      return localVarFp
        .getSupplierKey(requestParameters.search, requestParameters.page, requestParameters.pageSize, options)
        .then((request) => request(axios, basePath));
    }
  };
};
/**
 * SupplierApi - object-oriented interface
 */
export class SupplierApi extends BaseAPI {
  /**
   * Get supplier key and desc list
   * @param {SupplierApiGetSupplierKeyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getSupplierKey(requestParameters, options) {
    return SupplierApiFp(this.configuration)
      .getSupplierKey(requestParameters.search, requestParameters.page, requestParameters.pageSize, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
